import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import AppContent from "./pages/AppContent";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Offentlig side */}
        <Route path="/login" element={<Login />} />

        {/* Beskyttet side */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AppContent />
            </PrivateRoute>
          }
        />

        {/* Standard fallback */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;